import type { HeadingProps } from "@flare/ui/components";
import { Heading } from "@flare/ui/components";
import { cn } from "@flare/ui/utils";

export function StepTitle({ children, className, ...restProps }: HeadingProps) {
  return (
    <Heading
      variant="h3"
      alignment="center"
      textWrap="balance"
      className={cn("mx-auto mt-sp-4 max-w-[520px] md:text-h2", className)}
      {...restProps}
    >
      {children}
    </Heading>
  );
}
